import Color from "color";

export const red = "#EB5757";
export const darkRed = "#d04863";
export const functionalRed = "#F03F6C";
export const blue = "#206cd1";
export const strongBlue = "#1d59ab";
export const functionalBlue = "#528CDD";
export const dodgerBlue = "#2681FA";
export const darkBlue = "#091e3b";
export const midnightBlue = "#0d1440";
export const darkGreen = "#219653";
export const green = "#57CA81";
export const turmeric = "#A9B531";
export const darkOrange = "#F2994A";
export const orange = "#FF9435";
export const yellow = "#E1B827";
export const lightYellow = "#fffaec";
export const highlightYellow = "#ffffcc";
export const marine = "#004F9E";
export const cyan = "#00ACC1";
export const lightCyan = "#e6f7ff";
export const concrete = "#78909C";
export const pink = "#FFC0CB";
export const turquoise = "#247893";
export const goldWarning = "#BF8756";
export const mustard = "#DDAF32";
export const darkerBlue = "#110F26";

// new palette
export const greenGray = "#64748B";
export const darkGray = "#3E4856";
export const concreteWhite = "#E8EBEE";
export const regentGray = "#818ea1";
export const platinum = "#DADEE3";
export const vintageBlue = "#4A88DA";
export const fauxAliceBlue = "#f4f8fd";
export const adminBlue = "#181C21";

export const primaryBlue = "#1890ff";
export const lightBlue = "#5FD5F9";
export const lightPurple = "#f2f1fa";
export const winterMist = "#f2f2f2";
export const whiteSmoke = "#f5f5f5";
export const purple = "#827CC5";
export const darkLavender = "#281E93";
export const lavender = "#4A4398";
export const lightLavender = "#A49FD5";
export const lightPurpleGray = "#DCDAF9";
export const lightRed = "#FFE3E3";
export const blueberry = "#7065AD";
export const nearLightBlue = "#F7F9FF";

export const info = "#409BF6";
export const success = "#219653";
export const warning = "#F2994A";
export const error = "#EB5757";

export const black = "#000";
export const nearBlack = "#111";
export const midGray = "#555";
export const mediumLightGray = "#bbb";
export const lightMidGray = "#ddd";
export const gray = "#777";
export const silver = "#BCC3CD";
export const lightSilver = "#aaa";
export const moonGray = "#ccc";
export const lightGray = "#eee";
export const nearWhite = "#f4f4f4";
export const lightWhite = "#F7F8F9";
export const titanWhite = "#F3F2FF";
export const white = "#fff";
export const navy = "#5fd5f9";
export const gold = "#D4AF37";
export const iconWarning = "#D4A832";
export const functionalOrange0 = "#FFFCF2";
export const functionalOrange05 = "#FFF4CF";
export const borderColorDefault = "#DEE1EA";
export const linkDefault = "#1890FF";
export const iconInformation = "#4A8FF1";
export const textInformation = "#31578C";
export const backgroundNeutral = "#1F263C0F";
export const backgroundNeutralHovered = "#1F263C24";
export const helperTextDefault = "#818EA1";
export const secondaryButtonBackground = "#EDEEF4";
export const borderDefault = "#DEE1EA";
export const elevationSurfaceSubtlest = "#F7F9FF";
export const lightNeutralNeutral1000 = "#2B323C";
export const backgroundAccentNeutralSubtle = "#EDEEF4";
export const textSubtle = "#545F7E";
export const textInverse = "#FFFFFF";
export const blueGray = " #6a7494";
export const textDefault = "#111626";
export const accentBlueSubtler = "#DBECFF";
export const sublterGray = "#B6BED4";
export const backgroundAccentRedSubtlest = "#FFF2F5";
export const backgroundSuccess = "#11B46B";
export const textSubtlest = "#6A7494";
export const backgroundAccentGreenSubtlest = "#F2FFF9";
export const backgroundAccentNeutralSubtler = "#EBE8E5";
export const greenSubtle = "#62BC84";

// re-branding colors

export const inputBorder = "#E1DDDA";
export const sidebarBackground = "#012121";

export const colorBorderFocused = "#268D8B";
export const backgroundBrandBold = "#1F7A78";
export const backgroundBrandBoldHover = "#135757";
export const backgroundBrandBoldPressed = "#0C403F";
export const backgroundBrandBoldest = "#0B3433";
export const backgroundDangerBold = "#E1405C";
export const backgroundDangerBoldHover = "#BD344C";
export const backgroundDangerBoldPressed = "#8E2537";
export const backgroundSubtleDangerBold = "#FEEDED";
export const backgroundSubtleDangerBoldHover = "#FAD7D7";
export const backgroundSubtleDangerBoldPressed = "#F09196";
export const colorTextDefault = "#161514";
export const colorTextDisabled = "#9C938A";
export const backgroundDisabled = "rgba(1, 33, 33, 0.03)";
export const colorBackgroundNeutral = "rgba(1, 33, 33, 0.06)";
export const colorBackgroundNeutralHovered = "rgba(1, 33, 33, 0.12)";
export const colorBackgroundNeutralPressed = "rgba(1, 33, 33, 0.24)";
export const colorBackgroundNeutralSelected = "#B8EAE8";
export const textAccentInfoBolder = "#25517D";
export const colorBackgroundAccentCornfieldBlueSubtler = "#DEE9FF";
export const colorlinkDefault = "#4183C7";
//Cluster Policies and Cluster Templates
export const infoMessageBannerBorderLeft = "#9373A2";
export const infoMessageBannerBackground = "#E8E1EA";
export const infoMessageBannerTextContent = "#3F3C3A";
export const infoMessageBannerIcon = "#7E5C8E";
export const templateOverviewCardBorder = "#E5E3E3";
export const bannerAlertTextSecondaryColor = "#5F5C5A";
export const bannerAlertSecondaryBackground = "#EDF3FD";
export const backgroundSurfaceSubtlest = "#FAF9F8";
export const backgroundSurfaceSubtler = "#F3F0EE";
export const softLilac = "#7E5C8E";

export const colorLayersManifest = "#F09196";
export const colorLayersAi = "#37687C";
export const colorLayersHelm = "#55A0BE";
export const colorLayersRegistry = "#7E5C8E";
export const colorLayersAppServices = "#2EA7A4";
export const colorLayersServiceMesh = "#61396B";
export const colorLayersAuthentication = "#F0BE65";
export const colorLayersSecurity = "#E7A548";
export const colorLayersMonitor = "#5D823C";
export const colorLayersLogging = "#7E9A5A";
export const colorLayersLoadBalancer = "#CE5705";
export const colorLayersIngress = "#F19059";
export const colorLayersStoragePalette = "#1F7A78";
export const colorLayersNetworkPalette = "#005B5B";
export const colorLayersK8sPalette = "#004244";
export const colorLayersOsPalette = "#043736";

export const colorBackgroundAccentNeutralSubtler = "#EBE8E5";
export const colorIconDefault = "#3F3C3A";
export const colorIconSubtle = "#97938F";

export const STATUS_COLOR = {
  inactive: "#C4C4C4",
  unassigned: "#C4C4C4",
  paused: warning,
  pending: warning,
  pairing: warning,
  configured: navy,
  provisioned: info,
  importing: info,
  installing: info,
  provisioning: info,
  updating: info,
  pausing: warning,
  resuming: info,
  active: success,
  running: success,
  pass: success,
  success,
  warning,
  error,
  fail: error,
  deleting: error,
  deleted: error,
  info: blue,
  successful: green,
  failed: error,
  scheduled: info,
  initiated: info,
  completed: green,
  inprogress: info,
  low: blue,
  medium: warning,
  high: red,
  warn: warning,
  passed: green,
  succeeded: success,
  waiting: warning,
  terminated: "#C4C4C4",
  "in-use": info,
  ready: green,
  deploying: info,
  deployed: green,
};

export const BAR_CHART_COLORS = [
  "#4432F5",
  "#5FD5F9",
  "#AF26FA",
  "#D4AF37",
  "#003366",
  "#42d4f4",
  "#f032e6",
  "#bfef45",
  "#daa520",
  "#469990",
  "#8b0000",
  "#9A6324",
  "#8a2be2",
  "#00ced1",
  "#66cdaa",
  "#808000",
  "#f7347a",
  "#000075",
  "#ff4040",
].map((color) => Color(color).lighten(0.3).hex());

export const PURE_COREHOURS_CHART_COLOR = vintageBlue;

export const ALLOY_COREHOURS_CHART_COLOR = regentGray;

export const PROGRESS_BAR_COLORS = {
  paleGreen: "#C5F1E1",
  malibu: "#C3E8FC",
};

export const COST_CHART_COLORS = [
  "#D67BC0",
  "#98D6BE",
  "#B398D9",
  "#A2E6FB",
  "#E9B4E2",
  "#F8DABF",
];

export const USAGE_LINE_CHART_COLORS = {
  MAX: "#b398d9",
  AVG: "#febdb4",
};
